import { nameColumn } from "../../../../../layouts/Table/columns/nameColumn";
import { useCallback, useMemo, useState } from "react";
import { Avatar, Button, Flex, Group, ThemeIcon } from "@mantine/core";
import MainTable from "../../../../../layouts/Table/MainTable";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import numberColumn from "../../../../../layouts/Table/columns/numberColumn";
import { useListingLoader } from "../../../../../components/hooks/ListingHooks";
import {
  IconBuildingCommunity,
  IconChevronDown,
  IconWorld,
} from "@tabler/icons-react";
import { useListStore } from "../../../../../stores/ListStore";
import { updateSelf } from "../../../../../api/UserAPI";
import { useNavigate, useParams } from "react-router-dom";
import { getRowClasses } from "../listing";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../../stores/UserStore";

const UnsubscribersListing = () => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiRef();
  const { orgId } = useParams();
  const listId = useMemo(() => parseInt(orgId), [orgId]);

  const profile = useProfileStore((s) => s.profile);

  const columns = useMemo(() => {
    let result = [
      numberColumn(),
      nameColumn({
        headerName: lang.prospects.org_name,
        disableLink: true,
        handleClick: () => {},
        apiRef,
      }),
    ];

    return result;
  }, [apiRef]);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const actionsCell = useCallback(
    ({ row }) => {
      return (
        <Group wrap="nowrap" gap={4}>
          <IconChevronDown
            size={24}
            className="bump"
            opacity={listId === row.id ? 1 : 0.4}
            style={{
              transform: listId === row.id ? "rotate(-90deg)" : "none",
              transition: "all ease .3s",
            }}
            onClick={() => handleRowClick({ row })}
          />
        </Group>
      );
    },
    [listId]
  );

  const navigate = useNavigate();
  const handleRowClick = ({ row }) => {
    navigate(`/unsubscribers/${row.id}`);
  };

  useListingLoader({
    loading,
    setLoading,
    listGetter: updateSelf,
    responseField: "user_profile",
    setRows,
    getRows: (result) => {
      return result.organizations;
    },
  });

  return (
    <Flex w={"100%"} pos={"relative"} flex={1}>
      <Group
        pos={"absolute"}
        top={64}
        pt={20}
        w={"100%"}
        style={{
          borderTop: "1px solid #00000012",
        }}
      >
        {profile?.level === "admin" && (
          <Button
            style={{ zIndex: 7 }}
            variant={orgId === "admin" ? "filled" : "subtle"}
            fz={20}
            fw={600}
            radius={"md"}
            c={"black"}
            size="md"
            w={"100%"}
            justify="start"
            pl={7}
            h={52}
            leftSection={
              <ThemeIcon
                size={40}
                radius={"md"}
                color={orgId === "admin" ? "white" : "primary"}
              >
                <IconWorld />
              </ThemeIcon>
            }
            onClick={() => {
              navigate("/unsubscribers/admin");
            }}
          >
            Désinscrits de la plateforme
          </Button>
        )}
        <Button
          style={{ zIndex: 7 }}
          variant={orgId === "all" ? "filled" : "subtle"}
          fz={20}
          fw={600}
          radius={"md"}
          c={"black"}
          size="md"
          w={"100%"}
          justify="start"
          pl={7}
          h={52}
          leftSection={
            <ThemeIcon
              size={40}
              radius={"md"}
              color={orgId === "all" ? "white" : "primary"}
            >
              <IconBuildingCommunity />
            </ThemeIcon>
          }
          onClick={() => {
            navigate("/unsubscribers/all");
          }}
        >
          {lang.prospects.all_unsub}
        </Button>
      </Group>
      <MainTable
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        loading={loading}
        setLoading={setLoading}
        id={"list-table"}
        actionsCell={actionsCell}
        hasFolder
        // pageName={"contact_lists"}
        // pageOrderName={"contact_list_order"}
        actionsCellWidth={75}
        disableGotoPage
        disableVisibleColumns
        defaultPerPage={15}
        disablePerPage
        onRowClick={handleRowClick}
        // whiteButtons
        getRowClassName={(params) =>
          getRowClasses({ params, mainId: orgId, integerId: listId })
        }
        tableSx={{
          "& .MuiDataGrid-pinnedColumnHeaders": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-pinnedColumns": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-cell": {
            border: "none !important",
            borderRadius: 8,
          },
          "& .MuiDataGrid-columnHeaders": {
            border: "none !important",
            display: "flex",
          },
          "& .MuiDataGrid-main": {
            border: "none !important",
            borderRadius: 4,
            marginTop: profile?.level === "admin" ? 18 : 12,
            background: "none !important",
          },
          "& .table-row": {
            cursor: "pointer",
            borderRadius: 4,
            marginBottom: 1,
            background: "#fff !important",
            border: "1px solid var(--mantine-color-primary-1)",
          },
          "& .MuiDataGrid-pinnedColumns--right .table-row": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "none",
          },
          "& .MuiDataGrid-pinnedColumns--left .table-row": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: "none",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone .table-row": {
            borderRadius: 0,
            borderTopRightRadius: "0 !important",
            borderBottomRightRadius: "0 !important",
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden",
          },
          "& .MuiPagination-root": {
            left: 0,
            transform: "none",
          },
          "& .Mui-selected": {
            color: "",
          },
          "& .MuiDataGrid-footerContainer": {
            border: 0,
          },
          "& .table-search": {
            width: "180px !important",
          },
        }}
      />
    </Flex>
  );
};

export default UnsubscribersListing;
